/**
 * @description: 登录页
 * @author: ct
 * @update: hwx
 * @update: lyr
*/
<template>
	<div class="login">
		<div class="login-content">
			<!-- 登录 -->
			<div class="merchant-login" v-if="isLogin">
				<p class="login-title">商家登录</p>
				<div class="login-div">
					<input type="text" class="login-input" placeholder="请输入手机号" v-model="userTele" maxlength="11" />
				</div>
				<div class="login-div">
					<input type="password" class="login-input" placeholder="请输入密码" v-model="userpassword" @keyup.13="login" />
				</div>
				<button class="enter-btn" v-on:click="login">登录</button>
				<span class="forget-txt" v-on:click="clearLoginForget">忘记密码？</span>
			</div>
			<!-- 忘记密码 -->
			<div class="forget-password" v-else>
				<p class="login-title">重置密码</p>
				<div class="login-div">
					<input id="login_forPhone" type="text" value="" class="login-input" placeholder="请输入手机号" v-model="login_forPhone" maxlength="11" />
				</div>
				<div class="login-div">
					<input id="login_code" type="text" value="" class="login-input login-code" placeholder="请输入验证码" v-model="verify_code" />
					<button class="repeat-send" v-on:click="getCode">{{codeTxt}}</button>
				</div>
				<div class="login-div">
					<input type="password" v-model="forgetpassword" class="login-input" placeholder="设置密码" />
				</div>
				<div class="login-div">
					<input type="password" v-model="forgetpasswordSure" value="" class="login-input" placeholder="确认密码" />
				</div>
				<div class="login-div">
					<button class="login-sure forget-btn" v-on:click="verifyforget">确定</button>
					<button class="login-cancel forget-btn" v-on:click="clearLoginMain">取消</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import * as types from '@/store/types';
	export default {
		name: '',
		data() {
			return {
				isLogin: true,

				userTele: "",
				userpassword: "",

				isPhone: 1,
				login_forPhone: "",
				verify_code: "",
				codeTxt: '发送验证码',
				forgetpassword: "",
				forgetpasswordSure: "",
			}
		},
		created() {
			this.$store.commit(types.LOGOUT)
		},
		mounted: function() {
			// 管理后台跳转登录
			if(window.location.href.split("?")[1]) {
				let reg = new RegExp("(^|&)mobile=([^&]*)(&|$)");
				let csStr = window.location.href.split("?")[1];
				let r = csStr.match(reg);
				if(r != null) {
					this.userTele = unescape(r[2]);
					this.userpassword = '123456';
					this.login();
				}
			}
		},
		methods: {
			// 点击登录
			login() {
				const _this = this

				Vue.axios.post('User/public_login', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"mobile": _this.userTele,
							"password": _this.userpassword,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.$store.commit(types.LOGIN, {
							version: res.data.response.resault.web_version,
							versionurl: res.data.response.resault.login_url,
							version_name: res.data.response.resault.version_name,
							usermobile: res.data.response.resault.userdata.mobile,
							username: res.data.response.resault.userdata.name,
							mercid: res.data.response.resault.userdata.merchant_id,
							privinfo: res.data.response.resault.priv_info,
							token: _this.userpassword,
							shop_report_default_time: res.data.response.resault.setting_info.shop_report_default_time,
							business_model: res.data.response.resault.business_model,
							tx_ak: res.data.response.resault.tx_ak,
						})
						Vue.request_header.merchant_id = res.data.response.resault.userdata.merchant_id
						if(window.location.host.indexOf('localhost') < 0) {
							window.location.href = res.data.response.resault.login_url
						} else {
							// 本地
							_this.$router.push({
								path: '/'
							})
						}
						_this.getReportSystemInfo()
						_this.getAIModuleStatus()
					} else {
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("登录错误")
				})
			},
			// 点击忘记密码
			clearLoginForget() {
				this.login_forPhone = ""
				this.verify_code = ""
				this.forgetpassword = ""
				this.forgetpasswordSure = ""
				this.isLogin = false
			},
			// 倒计时，请求短信
			resetCode() {
				let _this = this;
				let second = 60;
				let timer = null;
				timer = setInterval(function() {
					second -= 1;
					if(second > 0) {
						_this.codeTxt = "重新发送(" + second + "s)";
						$(".repeat-send").attr("disabled", "true").addClass("disabled");
					} else {
						$(".repeat-send").removeAttr("disabled").removeClass("disabled");
						_this.codeTxt = "重新发送";
						clearInterval(timer);
					}
				}, 1000);

				Vue.axios.post('Sms/public_send', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"mobile": _this.login_forPhone,
							"scenario": "forget_passwd"
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {

					} else {
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
			},
			// 验证手机号码
			checkPhone(phone) {
				let _this = this;
				let pattern = /^1[0-9]{10}$/;
				_this.isPhone = 1;
				if(phone == '') {
					layer.msg('请输入手机号码');
					_this.isPhone = 0;
					return false;
				}
				if(!pattern.test(phone)) {
					layer.msg('请输入正确的手机号码');
					_this.isPhone = 0;
					return false;
				}
			},
			// 点击获取验证码
			getCode() {
				let _this = this;
				_this.checkPhone(_this.login_forPhone); // 验证手机号码
				if(_this.isPhone) {
					_this.resetCode(); // 倒计时
				}
			},
			// 确认修改密码
			verifyforget() {
				const _this = this;
				_this.checkPhone(_this.login_forPhone);
				if(_this.isPhone) { // 验证手机
					if(_this.forgetpasswordSure == _this.forgetpassword) { // 验证密码
						Vue.axios.post('User/public_changePasswordBySMS', {
							"header": Vue.request_header,
							"request": {
								"version": Vue.version,
								"param": {
									"mobile": _this.login_forPhone,
									"password_1": _this.forgetpassword,
									"password_2": _this.forgetpasswordSure,
									"verify_code": _this.verify_code
								}
							},
							"comment": ""
						})
						.then(res => {
							if(res.data.response.result_code == "true") {
								layer.msg("密码修改成功,3s后返回登录页面！");
								let seconds = 3;
								let timers = setInterval(function() {
									seconds -= 1;
									if(seconds <= 0) {
										clearInterval(timers);
										_this.clearLoginMain();
									}
								}, 1000);
							} else {
								layer.msg(res.data.response.error_msg)
							}
						})
						.catch(err => {
							layer.msg("出错啦")
						})
					} else {
						layer.msg("两次密码填写不一致");
					}
				}
			},
			// 取消
			clearLoginMain() {
				this.userTele = ""
				this.userpassword = ""
				this.isLogin = true
			},
			// 获取报表系统相关信息
			getReportSystemInfo() {
				const _this = this

				Vue.axios.post('System/getReportSystemInfo', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
				console.log('getReportSystemInfo',res);
				
					if(res.data.response.result_code == "true") {
						_this.$store.commit(types.REPORTINFO, {
							report_token: res.data.response.resault.token,
							report_base_url: res.data.response.resault.base_url
						})
					} else {
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
			},
			// 获取 AI 模块显示状态
			getAIModuleStatus() {
				const _this = this
				Vue.axios.post('AppModule/getPcModule', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
				// console.log(res);
				
					if(res.data.response.result_code == "true") {
						_this.$store.commit(types.AIMODULE, res.data.response.result)
						console.log(res.data.response.result);
					} else {
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
					console.dir(err);
				})
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.login {
		width: 86%;
		padding: 100px 0;
		margin: 0 auto;
		background: #3ba6e1;
		.login-content {
			width: 436px;
			height: 571px;
			padding-top: 70px;
			margin: 0 auto;
			background: url(../assets/images/login/login_bg.png) 0 0 no-repeat;
			.login-title {
				color: #03466b;
				font-size: 24px;
				text-align: center;
			}
			.login-div {
				display: flex;
				justify-content: space-between;
				width: 226px;
				margin: 30px auto 0;
			}
			.login-input {
				display: block;
				width: 194px;
				height: 32px;
				line-height: 32px;
				margin: 0 auto;
				border: 2px solid #009af0;
				border-radius: 32px;
				padding: 0 14px;
				font-size: 14px;
				outline: none;
				box-sizing: content-box;
			}
			.enter-btn {
				display: block;
				width: 220px;
				height: 34px;
				line-height: 34px;
				color: #fff;
				font-size: 20px;
				text-align: center;
    			background: linear-gradient(to right bottom, #189fea, #5dbff5);
				border: none;
				border-radius: 32px;
				margin: 30px auto 14px;
			}
			.forget-txt {
				display: block;
				color: #b0a3a3;
				font-size: 14px;
				text-align: center;
				cursor: pointer;
			}
			.login-code {
				width: 90px;
				margin: 0;
			}
			.repeat-send {
				width: 90px;
				height: 36px;
				border: none;
				color: #fff;
				font-size: 12px;
				background: linear-gradient(to right, #189fea, #5dbff5);
				border-radius: 34px;
			}
			.repeat-send.disabled {
				background: #ADADAD;
			}
			.forget-btn {
				display: block;
				width: 100px;
				height: 34px;
				border: none;
				color: #fff;
				font-size: 18px;
				background: linear-gradient(to right, #189fea, #5dbff5);
				border-radius: 34px;
			}
			.login-cancel {
				background: #fff;
				border: 2px solid #009af0;
				color: #009af0;
			}
		}
	}
</style>